define("shared/components/shared/profile-timezone-select", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _object, _service, _utils, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div data-test-id="profile-timezone-select" class="{{this.fadeIn}} {{this.wrapperClass}}" {{did-insert this.onInsert}}>
    {{#if this.showToggle}}
  
      <p class="u--m__tb__lg">
        {{t "authorization.create_account.timezone"}} {{@user.timeZone}}
        <a data-test-id="profile-timezone-select-toggle"
          class="u--text--black u--text--underline u--p__l qa--signup_toggle_timezone_selector"
          {{on "click" (set this "showToggle" false)}}
        >
          {{t "authorization.create_account.change"}}
        </a>
      </p>
  
    {{else}}
  
      <div class="u--fadeIn">
        <label for="time_zone_selector">
          {{t "account.overview.preferences.timezone"}}
        </label>
        {{#if @showGuessLink}}
          <a
            class="u--m__l__xs u--text--sm u--text--uppercase"
            onclick={{action "guessTimezone"}}
          >
            {{t "account.overview.preferences.guess_timezone"}}
          </a>
        {{/if}}
        <select
          data-test-id="profile-timezone-select-select"
          class="qa--signup_timezone_selector {{inputClass}}"
          id="time_zone_selector"
          {{on "change" this.setTimezone}}
        >
          {{#each this.allTimezones as |timezone|}}
            <option
              value={{timezone.name}}
              selected={{are-equal timezone.identifier @user.timeZoneIdentifier}}
            >
              {{timezone.name}}
            </option>
          {{/each}}
        </select>
      </div>
  
    {{/if}}
  </div>
  
  */
  {
    "id": "3lMSXzTE",
    "block": "[[[11,0],[24,\"data-test-id\",\"profile-timezone-select\"],[16,0,[29,[[30,0,[\"fadeIn\"]],\" \",[30,0,[\"wrapperClass\"]]]]],[4,[38,0],[[30,0,[\"onInsert\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showToggle\"]],[[[1,\"\\n    \"],[10,2],[14,0,\"u--m__tb__lg\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"authorization.create_account.timezone\"],null]],[1,\" \"],[1,[30,1,[\"timeZone\"]]],[1,\"\\n      \"],[11,3],[24,\"data-test-id\",\"profile-timezone-select-toggle\"],[24,0,\"u--text--black u--text--underline u--p__l qa--signup_toggle_timezone_selector\"],[4,[38,3],[\"click\",[28,[37,4],[[30,0],\"showToggle\",false],null]],null],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"authorization.create_account.change\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"]],[]],[[[1,\"\\n    \"],[10,0],[14,0,\"u--fadeIn\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,\"for\",\"time_zone_selector\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.overview.preferences.timezone\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[10,3],[14,0,\"u--m__l__xs u--text--sm u--text--uppercase\"],[15,\"onclick\",[28,[37,5],[[30,0],\"guessTimezone\"],null]],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"account.overview.preferences.guess_timezone\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[11,\"select\"],[24,\"data-test-id\",\"profile-timezone-select-select\"],[16,0,[29,[\"qa--signup_timezone_selector \",[36,6]]]],[24,1,\"time_zone_selector\"],[4,[38,3],[\"change\",[30,0,[\"setTimezone\"]]],null],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"allTimezones\"]]],null]],null],null,[[[1,\"          \"],[10,\"option\"],[15,2,[30,3,[\"name\"]]],[15,\"selected\",[28,[37,9],[[30,3,[\"identifier\"]],[30,1,[\"timeZoneIdentifier\"]]],null]],[12],[1,\"\\n            \"],[1,[30,3,[\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[3]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"]],[]]],[13],[1,\"\\n\"]],[\"@user\",\"@showGuessLink\",\"timezone\"],false,[\"did-insert\",\"if\",\"t\",\"on\",\"set\",\"action\",\"inputClass\",\"each\",\"-track-array\",\"are-equal\"]]",
    "moduleName": "shared/components/shared/profile-timezone-select.hbs",
    "isStrictMode": false
  });

  let ProfileTimezoneSelect = (_class = class ProfileTimezoneSelect extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "userConfig", _descriptor, this);

      _initializerDefineProperty(this, "alerts", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "showToggle", _descriptor4, this);

      _defineProperty(this, "fadeIn", 'u--fadeIn');

      _defineProperty(this, "defaultSize", 'lg');
    }

    get size() {
      return this.args.size || this.defaultSize;
    }

    get wrapperClass() {
      return 'o--formWrapper' + (this.size === 'lg' ? '--lg' : '');
    }

    get inputClass() {
      return 'o--form__select' + (this.size === 'lg' ? '--lg' : '');
    }

    get allTimezones() {
      return this.userConfig.timezones;
    }

    onInsert() {
      this.showToggle = this.args.showToggle || false;

      if ((0, _utils.isEmpty)(this.args.user.timeZone) || (0, _utils.isEmpty)(this.args.user.timeZoneIdentifier)) {
        this.guessTimezone();
      }
    }

    guessTimezone() {
      const timeZone = moment.tz.guess();
      this.args.user.timeZone = timeZone;
      this.args.user.timeZoneIdentifier = timeZone;
    }

    setTimezone(_ref2) {
      let {
        target: {
          value
        }
      } = _ref2;
      this.args.user.timeZone = value;
      this.args.user.timeZoneIdentifier = value;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showToggle", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "onInsert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "guessTimezone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "guessTimezone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTimezone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setTimezone"), _class.prototype)), _class);
  _exports.default = ProfileTimezoneSelect;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileTimezoneSelect);
});